import styled from 'styled-components';

export const TextButtonStyled = styled.button`
  background: transparent;
  border: none;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.brand.light.base};
`;
